import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import $dayjs from "@/plugins/days";
import {
  ProtestCategory,
  useProtestEventsStore,
} from "@/stores/protest-events";
import { useRoute } from "vue-router/composables";
import colors from "../stores/colors";


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalScatterChart',
  setup(__props) {

const route = useRoute();
const protestEventsStore = useProtestEventsStore();

let isLoading = ref<boolean>(true);
setTimeout(() => (isLoading.value = false), 0.1);

const queryCity = computed(() => {
  return protestEventsStore.cities.find(
    (city) => city.label === route.query.stadt?.toString()
  );
});

const city = ref<ProtestCategory[]>([]);
if (queryCity.value) {
  city.value = [queryCity.value];
}

const symbolSize = (totalParticipants: number): number => {
  return Math.sqrt(totalParticipants / Math.PI);
};

watch(queryCity, () => {
  if (queryCity.value) {
    city.value = [queryCity.value];
  }
});

const MAX_SYMBOL_SIZE = 40;

let r = 0;
const filteredProtestEvents = computed(() =>
  protestEventsStore
    .filteredProtestEvents(city.value, undefined, undefined, false, false)
    .sort(
      (a: any, b: any) =>
        $dayjs(a.date, "YYYY-MM-DD").startOf("month").unix() -
        $dayjs(b.date, "YYYY-MM-DD").startOf("month").unix()
    )
    .map((item: any, index: number, array: any) => {
      // data clean up
      item.date = $dayjs(item.date, "YYYY-MM-DD")
        .startOf("month")
        .format("YYYY-MM-DD");

      // calculate y scatter value
      let y = 0;
      if (index != 0) {
        if (item.date == array[index - 1].date) {
          if (index % 2 == 0) {
            y = -r - 1;
            r = r + 1;
          } else {
            y = r + 1;
          }
        } else {
          r = 0;
        }
      }
      return { ...item, y: y };
    })
);

const maxProtestParticipants = computed(() =>
  Math.max(
    ...new Set(
      filteredProtestEvents.value.map((e: any) => e.total_participants) as []
    )
  )
);

const categories = computed(() => [
  ...new Set(
    filteredProtestEvents.value
      .map((e: any) => {
        return e.claims[0];
      })
      .sort()
  ),
]);

const chartOptions = computed(() => ({
  legend: {},
  tooltip: {
    formatter: (tooltipData: any) => {
      const date = $dayjs.unix(tooltipData.data.value[0]).format("MMMM YYYY");
      const participants = tooltipData.data.participants
        ? tooltipData.data.participants.toLocaleString("de")
        : "<i>Konnte nicht ermittelt werden</i>";
      const forms = tooltipData.data.forms;
      const claims = tooltipData.data.claims;
      const colorSpan =
        '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
        tooltipData.color +
        '"></span>';

      return (
        `<center>` +
        colorSpan +
        `<strong>${tooltipData.data.city}</strong> - ${date}</center>
        <br /><strong>Teilnehmende: </strong>${participants}
        <br /><strong>Protestformen: </strong>${forms}
        <br /><strong>Protestthemen: </strong>${claims}`
      );
    },
  },
  xAxis: { type: "time", show: false },
  yAxis: { type: "value", show: false },
  grid: { containLabel: true },
  series: categories.value.map((category: any, index: any) => {
    return {
      type: "scatter",
      name: category === undefined ? "Keine Angabe" : category,
      color: category === undefined ? "lightgrey" : colors[index],
      data: filteredProtestEvents.value
        .filter((e: any) => category === e.claims[0])
        .map((e: any) => {
          //  console.log(symbolSize(e.total_participants), e.total_participants);
          return {
            value: [$dayjs(e.date).unix(), e.y, e.total_participants],
            city: e.city,
            participants: e.total_participants,
            forms: e.forms != "" ? e.forms.join(",") : "-",
            claims: e.claims != "" ? e.claims.join(",") : "-",
            itemStyle: {
              opacity: e.total_participants ? 1 : 0.4,
            },
            symbolSize: e.total_participants
              ? 4 +
                (MAX_SYMBOL_SIZE / symbolSize(maxProtestParticipants.value)) *
                  symbolSize(e.total_participants)
              : 4,
          };
        }),
    };
  }),
}));

return { __sfc: true,route, protestEventsStore, isLoading, queryCity, city, symbolSize, MAX_SYMBOL_SIZE, r, filteredProtestEvents, maxProtestParticipants, categories, chartOptions }
}

})